import { render, staticRenderFns } from "./LeaseAppraisal.vue?vue&type=template&id=13f011a2&scoped=true&"
import script from "./LeaseAppraisal.vue?vue&type=script&lang=ts&"
export * from "./LeaseAppraisal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f011a2",
  null
  
)

export default component.exports